import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import PersonIcon from 'components/icons/person-silhouette';
import TimeIcon from 'components/icons/time';
import SectionHeading from 'pages/cart/section-heading';

const CateringOrderDetailsWrapper = styled.div`
  grid-area: orderDetails;
`;
const DetailsSectionWrapper = styled.div`
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  display: grid;
  row-gap: 12px;
  padding: 12px;
`;
const DetailsSection = styled.div`
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  display: grid;
`;
const PersonDetails = styled(DetailsSection)`
  grid-template-areas:
    'personIcon orderedByHeader'
    'personIcon textOrderedBy'
    'personIcon textPhoneNumber'
    'personIcon textEmail';
`;
const TimeDetails = styled(DetailsSection)`
  grid-template-areas:
    'timeIcon timeHeader'
    'timeIcon detailTextDate'
    'timeIcon detailTextTime';
`;
const PersonIconStyled = styled(PersonIcon)`
  margin-top: 0.1rem;
  grid-area: personIcon;
`;

const TimeIconStyled = styled(TimeIcon)`
  margin-top: 0.1rem;
  grid-area: timeIcon;
`;
const DetailBlockHeader = styled.div`
  font-weight: ${Styles.fontWeight.heavy};
  grid-area: detailHeader;
  text-transform: capitalize;
  font-size: 14px;
`;

const DetailBlockHeaderOrderedBy = styled(DetailBlockHeader)`
  grid-area: orderedByHeader;
`;

const DetailBlockHeaderTime = styled(DetailBlockHeader)`
  grid-area: timeHeader;
`;

const DetailTextOrderedBy = styled.div`
  grid-area: textOrderedBy;
`;

const DetailTextPhoneNumber = styled.div`
  grid-area: textPhoneNumber;
`;

const DetailTextEmail = styled.div`
  grid-area: textEmail;
`;

const DetailTextDate = styled.div`
  grid-area: detailTextDate;
`;

const DetailTextTime = styled.div`
  grid-area: detailTextTime;
`;

declare interface ICateringOrderDetails {
  customerName: string;
  pickupAtDate: string;
  pickupAtTime: string;
  phoneNumber: string;
  email: string;
}
export const CateringOrderDetails: React.FC<ICateringOrderDetails> = ({
  customerName,
  pickupAtDate,
  pickupAtTime,
  phoneNumber,
  email,
}) => {
  const { formatMessage } = useIntl();
  return (
    <CateringOrderDetailsWrapper>
      <SectionHeading>{formatMessage({ id: 'orderDetailsHeading' })}</SectionHeading>
      <DetailsSectionWrapper>
        <PersonDetails>
          <PersonIconStyled width={18} height={18} fill={Styles.color.primary} />
          <DetailBlockHeaderOrderedBy>
            {formatMessage({ id: 'orderPlacedBy' })}
          </DetailBlockHeaderOrderedBy>
          <DetailTextOrderedBy>{customerName}</DetailTextOrderedBy>
          <DetailTextPhoneNumber>{phoneNumber}</DetailTextPhoneNumber>
          <DetailTextEmail>{email}</DetailTextEmail>
        </PersonDetails>
        <TimeDetails>
          <TimeIconStyled width={18} height={18} fill={Styles.color.primary} />
          <DetailBlockHeaderTime>{`${formatMessage({ id: 'pickUpTime' })}:`}</DetailBlockHeaderTime>
          <DetailTextDate>{pickupAtDate}</DetailTextDate>
          <DetailTextTime>{pickupAtTime}</DetailTextTime>
        </TimeDetails>
      </DetailsSectionWrapper>
    </CateringOrderDetailsWrapper>
  );
};
